import { ref } from 'vue'
import { getAgentStoreList } from '@/utils/http/modules/agent/agent.request'

export class AgentStore {
  constructor(options = {}) {
    /** 代理下级门店列表 */
    this.list = ref([])
    this.loading = ref(false)
    this.loaded = ref(false)
    this.page = ref(1)
    this.pageSize = ref(10)
    this.total = ref(0)
    this.agent = ref({})
    this.canToggle = ref(false)
    this.currentStore = ref({ storeId: '', storeName: '' })
    this.options = options
    this.resetList().finally(() => {
      if (typeof this.options.afterResetList === 'function') {
        this.options.afterResetList()
      }
    })
  }

  /** 重置列表 */
  async resetList() {
    this.loading.value = false
    this.loaded.value = false
    this.page.value = 1
    this.pageSize.value = 10
    this.total.value = 0
    this.list.value = []
    await this.getList()
  }

  /** 获取列表 */
  async getList(params = {}) {
    if (this.loading.value || this.loaded.value) return
    this.loading.value = true
    try {
      const res = await getAgentStoreList({
        ...params,
        pageIndex: this.page.value,
        pageSize: this.pageSize.value,
        zbId: window.zbvd.zbid,
      })
      if (res.code === 0 && res.dataObj) {
        const data = res.dataObj
        this.list.value = [...this.list.value, ...data.rows]
        this.total.value = data.totalRows || 0
        this.agent.value = data.customMaps || {}
        this.loaded.value = this.list.value.length >= this.total.value
        this.initCurrentStore()
      }
    } catch (error) {
      console.error('获取门店列表失败：', error)
    } finally {
      this.loading.value = false
    }
    this.loading.value = false
  }

  /** 加载更多 */
  loadMore() {
    if (this.loading.value || this.loaded.value) return
    this.page.value++
    this.getList()
  }

  /** 代理是否有绑定门店 */
  hasAgentBindStore() {
    return this.agent.value.agentStoreId > 0
  }

  /** 重置当前门店 */
  resetCurrentStore() {
    this.currentStore.value = {
      storeId: '',
      storeName: '',
    }
  }

  /**
   * 设置当前门店
   * @param {Object} store
   * @param {Number} store.storeId
   * @param {String} store.storeName
   */
  setCurrentStore(store) {
    if (!store) return
    this.currentStore.value = store
  }

  /** 普通代理 */
  agentV1Action() {
    this.canToggle.value = false
    if (!this.hasAgentBindStore()) {
      this.resetCurrentStore()
      return
    }
    this.setCurrentStore({
      storeId: this.agent.value.agentStoreId,
      storeName: this.agent.value.agentStoreName,
    })
  }

  /** v2代理及以上 */
  agentV2AndV3Action() {
    this.canToggle.value = this.list.value.length > 0
    if (!this.hasAgentBindStore()) {
      if (this.list.value.length > 0) {
        // 未绑定门店，默认选中第一个门店
        const firstStore = this.list.value[0]
        this.setCurrentStore({
          storeId: firstStore.storeId,
          storeName: firstStore.storeName,
        })
        return
      }
      // 未绑定门店且下级绑定门店列表为空
      this.resetCurrentStore()
      return
    }
    this.setCurrentStore({
      storeId: this.agent.value.agentStoreId,
      storeName: this.agent.value.agentStoreName,
    })
  }

  adminAction() {
    this.resetCurrentStore()
    this.canToggle.value = true
    if (this.list.value.length > 0) {
      // 未绑定门店，默认选中第一个门店
      const firstStore = this.list.value[0]
      this.setCurrentStore({
        storeId: firstStore.storeId,
        storeName: firstStore.storeName,
      })
      return
    }
  }

  initCurrentStore() {
    if (this.agent.value.isAgent) {
      const levelAction = {
        1: this.agentV1Action.bind(this),
        2: this.agentV2AndV3Action.bind(this),
        3: this.agentV2AndV3Action.bind(this),
      }
      levelAction[this.agent.value.agentLevel]?.()
    } else {
      // 管理员
      this.adminAction()
    }
  }
}
